import type { Seat } from './protocol';

/**
 * Chi ha lasciato, in una RESA (`reason: 'resign'`): la resa assegna la partita a chi resta, quindi chi non ha vinto e quello che ha abbandonato. Con un vincitore noto e il
 * mio posto noto risponde `io` o `avversario` e la schermata del risultato lo DICE («Hai abbandonato», «L'avversario ha abbandonato») al posto di un esito a punti: il
 * punteggio cumulato accanto a una partita persa per resa («Hai perso +1 punti») era una frase che si contraddice (il server sottrae la penale e il cumulato di chi ha
 * perso per resa puo restare positivo). `forfeit` e `abandoned` restano neutri (il testo di `reasonKey` nella schermata). Senza vincitore o senza posto → `null`, il neutro di sempre.
 */
export function chiHaAbbandonato(reason: string, winner: Seat | null, mySeat: Seat | null): 'io' | 'avversario' | null {
  if (reason !== 'resign' || winner === null || mySeat === null) return null;
  return winner === mySeat ? 'avversario' : 'io';
}
